module.exports = "../img/Tarjeta_ClubLN.png";


//////////////////
// WEBPACK FOOTER
// ./Statics/img/Tarjeta_ClubLN.png
// module id = 39
// module chunks = 0